<script>
import FormElement from '@wielink-application/shared/vue/components/form/horizontal/datetime.vue'

export default FormElement;
</script>